<div class="page-wrapper">
  <app-breadcrumbs *ngIf="auth.isAuthenticated()"></app-breadcrumbs>
  <section class="content-container">
    <div class="content-wrapper" *ngIf="!pageRetrievalError">
      <h1>{{ pageData.title }}</h1>
      <div class="separator"></div>
    </div>
    <div class="flex-container content-wrapper">
      <div class="text-container">
        <app-page-retrieval-error
          *ngIf="pageRetrievalError"
        ></app-page-retrieval-error>
        <div class="contact-options" *ngIf="!pageRetrievalError">
          <h3 class="intro">{{ pageData.intro }}</h3>
          <div class="separator"></div>
          <div
            class="contact-option"
            *ngFor="let contactOption of pageData.contact_options"
          >
            <app-cms-link
              [link]="contactOption"
              [class]="'contact-option-link'"
            >
              <div class="contact-option-text">
                <h3>{{ contactOption.contact_title }}</h3>
                <p>{{ contactOption.contact_intro }}</p>
              </div>
              <span class="option-arrow"></span>
            </app-cms-link>
          </div>
        </div>
      </div>
      <div class="image-container">
        <img [src]="pageData.image_web?.data?.attributes?.url" alt="" />
      </div>
    </div>
    <img
      class="mobile-image"
      [src]="pageData.background_image_app?.data?.attributes?.url"
      alt=""
    />
  </section>
</div>
